import React from 'react'
import { PageContent, Image } from 'components/library'
import { TooltipModal } from './component/TooltipModal.js'

import mainBG from './assets/mainBG.jpg'
import img01 from './assets/img01.jpg'
import img02 from './assets/img02.jpg'
import img03 from './assets/img03.jpg'
import img04 from './assets/img04.jpg'
import img05 from './assets/img05.jpg'
import img06 from './assets/img06.jpg'

import './Aspect01.css'

class Aspect01 extends React.Component {

  render() {
    return (
      <div className="Chapter04-Aspect01">
        <PageContent nospacing>
          <div className="Tooltip-info-messages">
              <Image src={mainBG} aspectRatio={59} />
              <TooltipModal
                tooltipTitle={'Rode toplichten'}
                modalNr={'01'}
                modalImage={img01}
                modalTitle={'Rode toplichten'}
                modalContent={'Het begeleidingsvoertuig moet op het hoogste punt van het voertuig twee rode toplichten hebben.'}
              />

              <TooltipModal
                tooltipTitle={'Amberkleurig zwaailicht'}
                modalNr={'02'}
                modalImage={img02}
                modalTitle={'Amberkleurig zwaailicht'}
                modalContent={'Het begeleidingsvoertuig moet een amberkleurig zwaailicht hebben.'}
              />

              <TooltipModal
                tooltipTitle={'Transponder'}
                modalNr={'03'}
                modalImage={img03}
                modalTitle={'Transponder'}
                modalContent={'Het begeleidingsvoertuig moet voorzien zijn van een werkende transponder, zodat de begeleider ook actief gevolgd kan worden door Apron Control.'}
              />

              <TooltipModal
                tooltipTitle={'Radio'}
                modalNr={'04'}
                modalImage={img04}
                modalTitle={'Radio'}
                modalContent={'Het begeleidingsvoertuig moet voorzien zijn van een werkende radio. Als je een defecte transponder hebt moet het begeleidingvoertuig de ontvangstmogelijkheid voor de sleepfrequenties (121.780 MHz en 121.880 MHz) en het baankanaal hebben.'}
              />

              <TooltipModal
                tooltipTitle={'Begeleider'}
                modalNr={'05'}
                modalImage={img05}
                modalTitle={'Begeleider'}
                modalContent={'Je wordt begeleid door een medewerker van Schiphol. Alleen in het geval van een defect anti-collisionlight is je afhandelaar verantwoordelijk voor de begeleiding. In alle gevallen moet de begeleider  veldbevoegdheid A of een sleepbevoegdheid bezitten.'}
              />

              <TooltipModal
                tooltipTitle={'Lettercode'}
                modalNr={'06'}
                modalImage={img06}
                modalTitle={'Lettercode'}
                modalContent={'In het geval dat je transponder kapot is, moet het begeledingsvoertuig voorzien zijn van een roepnaam met maximaal twee karakters.'}
              />
               
            </div>
        </PageContent>
      </div>
    )
  }
}

export default Aspect01



// WEBPACK FOOTER //
// ./src/content/chapters/04/01/Aspect01.js